module.exports = __webpack_public_path__ + "img/serpent.6f6ee293.jpg";